import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import Button from "./Button";
import { useDispatch, useSelector } from "react-redux";
import { GetParamsData } from '$Deposits/lib/LibCommonData'

export default function UploadFileModal(props) {
  const { visible, setVisible, RemoveUploadFile, SetUploadFileList, fileName, UploadFileErr, toggleLoading } = props
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [uploadMethod, setUploadMethod] = useState(null);
  const dispatch = useDispatch()
  const { webPiwikUrl } = GetParamsData();
  const reduxState = useSelector(state => state)
  const { MethodCodeActive, DepositOldBank } = reduxState

  useEffect(() => {
    if (uploadMethod) {
      if (uploadMethod === "gallery") {
        document.getElementById('fileField').removeAttribute("capture");
        document.getElementById('fileField').setAttribute("accept", "image/*")
      }
      if (uploadMethod === "file") {
        document.getElementById('fileField').removeAttribute("capture");
        document.getElementById('fileField').setAttribute("accept", "image/*,application/pdf");
      }
      upload();
      setUploadMethod(null)
    }
  }, [uploadMethod])

  useEffect(() => {
    if (visible) {
      if (DepositOldBank) {
        webPiwikUrl("deposit_old_bank_uploadslip_popup", "Old Bank Deposit Upload Slip Pop Up")
      } else {
        if (MethodCodeActive === "NormalAmt") {
          webPiwikUrl("deposit_local_bank_uploadslip_popup", "Local Bank Deposit Upload Slip Pop Up")
        } else if (MethodCodeActive === "UniqueAmt ") {
          webPiwikUrl("deposit_local_bank_unique_amounr_uploadslip_popup", "Local Bank Unique Amount Deposit Upload Slip Pop Up")
        }
      }
    }
  }, [visible])

  function checkFile(file) {  // 验证img 
    document.getElementById('form').reset();

    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      toggleLoading()
      const { name, size } = file
      let fileBytes = e.target.result
      fileBytes = fileBytes && fileBytes.split('base64,')[1] && fileBytes.split('base64,')[1]
      let data = { fileName: name, fileSize: size, fileBytes }
      SetUploadFileList(data)
    };
  }

  function upload() {
    document.getElementById('fileField').click();
  }

  function closeModal() {
    setVisible(false)
    if (!DepositOldBank) {
      if (MethodCodeActive === "NormalAmt") {
        webPiwikUrl("deposit_lb_bank", "Local Bank Deposit Page")
      } else if (MethodCodeActive === "UniqueAmt ") {
        webPiwikUrl(`deposit_lb_${MethodCodeActive}_bank`, `Local Bank ${MethodCodeActive} Deposit Page`)
      }
    } else {
      webPiwikUrl(`deposit_old_bank`, `Old Bank Deposit Page`)
    }
  }

  return (
    <>
      <Modal
        className='uploadModal'
        visible={visible}
        setVisible={setVisible}
        title='Đăng Tải Biên Lai' //上傳匯款證明
        cancelText='Hủy' //關閉
        okText='Gửi' //上傳
        disabled={!fileName || UploadFileErr}
        onCancel={() => {
          RemoveUploadFile()
          closeModal(false)
        }}
        onOk={() => {
          toggleLoading()
          closeModal(false)
        }}
      >
        <>
          <p className="intro">
            Kích thước tệp tối đa: 4MB | Loại tệp: JPG, JPEG, PNG, GIF, PDF, HEIC, HEIF | Số tệp tối đa: 1
          </p>
          <p className='inputTitle upload_title' data-CN="存款憑證">Biên Lai Gửi Tiền</p>
          <div className="upload_box">
            <lable className="fileName" id="fileName">{fileName}</lable>
            <form id='form'>
              <input style={{ display: 'none' }} type='file' id="fileField" onChange={() => {
                let file = document.getElementById('fileField').files[0];
                setIsDrawerVisible(false)
                checkFile(file)
              }} />
            </form>
            <Button data-CN="選擇檔案" onClick={() => { setUploadMethod("gallery") }}>Tải Lên</Button>
          </div>
          <div className="uploadError">{UploadFileErr}</div>
        </>
      </Modal>
    </>
  );
}


